import type { LucideIcon } from 'lucide-react';
import {
  Calendar,
  CheckCircle,
  Clock,
  FileText,
  Target,
  TrendingUp,
  UserMinus,
  Users,
  Wallet,
} from 'lucide-react';

export const ANALYTICS_STAT_IDS = [
  'totalClients',
  'activeClients',
  'plans',
  'todaySessions',
  'weekSessions',
  'pending',
  'churn',
  'ltv',
  'conversion',
] as const;

export type AnalyticsStatId = (typeof ANALYTICS_STAT_IDS)[number];

export function isAnalyticsStatId(id: string | undefined): id is AnalyticsStatId {
  return ANALYTICS_STAT_IDS.includes(id as AnalyticsStatId);
}

export type AnalyticsStatMeta = {
  id: AnalyticsStatId;
  titleKey: string;
  icon: LucideIcon;
  accent: string;
};

export const ANALYTICS_STATS: AnalyticsStatMeta[] = [
  {
    id: 'totalClients',
    titleKey: 'Всего клиентов',
    icon: Users,
    accent: 'from-blue-500/15 to-blue-500/5 text-blue-600',
  },
  {
    id: 'activeClients',
    titleKey: 'Активные клиенты',
    icon: TrendingUp,
    accent: 'from-emerald-500/15 to-emerald-500/5 text-emerald-600',
  },
  {
    id: 'plans',
    titleKey: 'Планы тренировок',
    icon: FileText,
    accent: 'from-violet-500/15 to-violet-500/5 text-violet-600',
  },
  {
    id: 'todaySessions',
    titleKey: 'Сессии сегодня',
    icon: Calendar,
    accent: 'from-amber-500/15 to-amber-500/5 text-amber-600',
  },
  {
    id: 'weekSessions',
    titleKey: 'Сессии за неделю',
    icon: CheckCircle,
    accent: 'from-indigo-500/15 to-indigo-500/5 text-indigo-600',
  },
  {
    id: 'pending',
    titleKey: 'Ожидают подтверждения',
    icon: Clock,
    accent: 'from-orange-500/15 to-orange-500/5 text-orange-600',
  },
  {
    id: 'churn',
    titleKey: 'Отток за 30д',
    icon: UserMinus,
    accent: 'from-rose-500/15 to-rose-500/5 text-rose-600',
  },
  {
    id: 'ltv',
    titleKey: 'Средний LTV',
    icon: Wallet,
    accent: 'from-teal-500/15 to-teal-500/5 text-teal-600',
  },
  {
    id: 'conversion',
    titleKey: 'Конверсия потенциальных клиентов',
    icon: Target,
    accent: 'from-cyan-500/15 to-cyan-500/5 text-cyan-600',
  },
];

export function getAnalyticsStatMeta(id: AnalyticsStatId): AnalyticsStatMeta {
  return ANALYTICS_STATS.find((stat) => stat.id === id)!;
}
